import React from 'react';
import { FormattedMessage } from 'react-intl';

enum EAuthError {
  INVALID_CREDENTIALS = 'invalid_credentials',
  DEFAULT = 'default',
  SSO_SAML_STRATEGY_ERROR = 'SsoSamlStrategyError',
  SSO_SIGNIN_ERROR = 'SsoSigninError',
  SSO_AUTHENTICATE_ERROR = 'SsoAuthenticateError',
}

type TErrorMsgFactory = (
  msg?: string | null
) => {
  id: string;
  defaultMessage: string;
  description: string;
};

const errorMessages: { [key: string]: TErrorMsgFactory } = {
  [EAuthError.INVALID_CREDENTIALS]: () => ({
    id: 'auth.error.invalidCredentials',
    defaultMessage:
      'There was a problem with your login information, please try again.',
    description: 'An error that happens during signin',
  }),
  [EAuthError.SSO_SAML_STRATEGY_ERROR]: errorMsg => ({
    id: 'auth.error.ssoSamlStrategyError',
    defaultMessage: 'There was a problem with SAML: {errorMsg}',
    description: 'An error that happens during signin',
    values: { errorMsg },
  }),
  [EAuthError.SSO_SIGNIN_ERROR]: errorMsg => ({
    id: 'auth.error.ssoSigninError',
    defaultMessage: 'Could not sign the user in: {errorMsg}',
    description: 'An error that happens during signin',
    values: { errorMsg },
  }),
  [EAuthError.SSO_AUTHENTICATE_ERROR]: errorMsg => ({
    id: 'auth.error.ssoAuthenticateError',
    defaultMessage: 'Error in SAML authentication: {errorMsg}',
    description: 'An error that happens during signin',
    values: { errorMsg },
  }),
  [EAuthError.DEFAULT]: () => ({
    id: 'auth.error.defaultError',
    defaultMessage: 'An error occurred, please try again.',
    description: 'An error that happens during signin (unknown reason)',
  }),
};

const isValidError = (error: string | null): error is EAuthError =>
  !!error && Object.values(EAuthError).indexOf(error as EAuthError) !== -1;

export const getErrorMessage = (
  error: string | null,
  message?: string | null
) => (
  <FormattedMessage
    {...(isValidError(error)
      ? errorMessages[error]
      : errorMessages[EAuthError.DEFAULT])(message)}
  />
);
